import React, { Component } from 'react'
import PropTypes from 'prop-types'
import EditGatewayForm from '../components/forms/EditGatewayForm'
import { Anchor } from './common/Anchor'
import FormHeader from './common/FormHeader'
import { createGatewayAction } from '../actions/gatewaysActions'
import { createQueryString } from '../utils/queryParams'
import api from '../services/api'
import { hasPermission } from '../utils/hasPermission'
import { USER_PERMISSIONS } from '../constants'

class CreateGateway extends Component {
  static propTypes = {
    tags: PropTypes.arrayOf(PropTypes.object),
    getAllTags: PropTypes.func.isRequired,
    getAllAssetLocations: PropTypes.func.isRequired,
    assetLocations: PropTypes.arrayOf(PropTypes.object).isRequired,
    modemTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
    getAllModemTypes: PropTypes.func.isRequired,
  }

  state = { nextPillarId: undefined }

  componentDidMount() {
    const { getAllAssetLocations, getAllTags, getAllModemTypes } = this.props
    api
      .getNextGatewayPillarId()
      .then(({ pillarId }) => this.setState({ nextPillarId: pillarId }))
      .catch(e => console.error(e))
    const qs = createQueryString({ perPage: 'all' })
    getAllAssetLocations(qs)
    hasPermission(USER_PERMISSIONS.VIEW_MODEM_AND_CARRIER) &&
      getAllModemTypes(qs)
    getAllTags(
      createQueryString({
        perPage: 'all',
      })
    )
  }

  render() {
    const { tags, assetLocations, modemTypes } = this.props
    const { nextPillarId } = this.state
    const crumbs = [
      <Anchor to="/inventory/all">Inventory</Anchor>,
      <Anchor to="/inventory/all/gateways">Network Gateways</Anchor>,
      'Create Network Gateway',
    ]

    return (
      <section className="CreateGateway">
        <FormHeader crumbs={crumbs} />
        <EditGatewayForm
          assetLocations={assetLocations}
          modemTypes={modemTypes}
          submitAction={createGatewayAction}
          tags={tags}
          initialValues={{ tagIds: [] }}
          isCreate
          nextPillarId={nextPillarId}
        />
      </section>
    )
  }
}

export default CreateGateway
